spApp.controller('LessonPlayerController', ['$scope', '$window', function ($scope, $window) {
  $scope.back = () => {
    $window.location.href = `http://${$window.location.host}/today-lesson`;
  };
}]);
